import type { GiftProductApiDto } from '__generated__/api/unauth/types.gen';

import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
import { ROUTES } from '@/constants';

import { HorizontalSlider } from './HorizontalSlider';
import { SectionHeader } from './SectionHeader';

const PREVIEW_SLIDER_COUNT = 5;

export function GiftPreviewSection({
  keyword,
  items,
  totalCount,
  isLoading,
}: {
  keyword: string;
  items: GiftProductApiDto[];
  totalCount: number;
  isLoading: boolean;
}) {
  if (!isLoading && items.length < 1) return null;

  return (
    <section className="flex w-full flex-col">
      <SectionHeader
        title="답례품"
        totalCount={totalCount}
        moreHref={ROUTES.SEARCH.withSearchParams({
          searchParams: { q: keyword || undefined, category: 'gifts' },
        })}
      />
      {isLoading ? (
        <HorizontalSlider className="mobile-tablet:pl-20">
          {Array.from({ length: PREVIEW_SLIDER_COUNT }, (_, index) => (
            <div
              key={index}
              className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"
            >
              <GiftListItem isLoading />
            </div>
          ))}
        </HorizontalSlider>
      ) : (
        <HorizontalSlider className="mobile-tablet:pl-20">
          {items.map((item) => (
            <div
              key={item.productNumber ?? item.productId}
              className="max-w-220 flex-[0_0_calc((100%-24px)/2.5)] mobile:min-w-160"
            >
              <GiftListItem
                mainImageUrl={item.mainImageUrl}
                productName={item.productName}
                donationAmount={item.requiredDonationAmount}
                reviewRating={item.reviewRating}
                reviewCount={item.reviewCount}
                productNumber={item.productNumber}
                responsiveClassName={{ productName: 'min-h-[2lh]' }}
              />
            </div>
          ))}
        </HorizontalSlider>
      )}
    </section>
  );
}
